export class FlexLength {
  constructor(public readonly factor: number) {}
}
